import { COMMERCE, SITE } from '@/config/site';
import { getBrandName } from '@/data/brands';
import { formatCents } from '@/lib/money';

import type { CartSummary } from '../cart/cart.types';

/** wa.me descarta payloads muito longos; fica bem dentro da faixa segura. */
const MAX_MESSAGE_LENGTH = 3500;

/**
 * Transforma a lista escolhida na mensagem que abre a conversa.
 *
 * O site não coleta nome, endereço nem forma de pagamento: isso é combinado na
 * conversa, com uma pessoa. A mensagem carrega só o que a equipe precisa para
 * responder na primeira resposta — produto, tamanho, quantidade e SKU.
 */
export function buildListMessage(summary: CartSummary): string {
  const lines: string[] = [];

  lines.push('🐾 *Olá! Montei minha lista no site da BrucePets.*');
  lines.push('');
  lines.push(`📋 *Itens (${summary.itemCount})*`);

  summary.lines
    .filter((line) => !line.isUnavailable)
    .forEach((line, index) => {
      lines.push(`${index + 1}. *${line.product.name}*`);
      lines.push(
        `   ${getBrandName(line.product.brandId)} · ${line.variant.label} · ${line.quantity}x`,
      );

      if (COMMERCE.showPrices) {
        lines.push(`   ${formatCents(line.lineTotalCents)}`);
      }

      lines.push(`   _SKU ${line.sku}_`);
    });

  if (COMMERCE.showPrices) {
    lines.push('');
    lines.push(`💰 *Estimativa pelo site:* ${formatCents(summary.subtotalCents)}`);
    if (summary.isEligibleForFreeShipping) {
      lines.push('🚚 Pela tabela do site, minha entrega seria grátis.');
    }
  }

  lines.push('');
  lines.push('Pode confirmar disponibilidade, valor final e entrega?');
  lines.push('');
  lines.push(`_Lista gerada em ${SITE.url.replace('https://', '')}_`);

  const message = lines.join('\n');

  if (message.length <= MAX_MESSAGE_LENGTH) return message;

  // Listas muito grandes: manda o essencial e deixa a equipe perguntar o resto.
  return (
    `${message.slice(0, MAX_MESSAGE_LENGTH)}\n\n` +
    '⚠️ _Lista grande — foi cortada aqui. Posso enviar o restante por mensagem._'
  );
}
